// const $window = $(window);
// let windowWidth = $window.width();
// var _isTest = false;

// // メディアクエリ
// let mql = window.matchMedia('screen and (max-width: 1024px)');

//pageTop
import {pageTop} from "../include/module";
pageTop();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//preload
import {preload} from "../include/module";
preload();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//showMovie
import {showMovie} from "../include/module";
showMovie();


$(window).on('load' , function() {

  //objectFit
  objectFitImages();

  movieSlide();

  scrollAnime();

  showKV();

  dlcBnr();
});


// ------------------------------------------------------------------------
// dlcBnr
// ----- BOTH
// ------------------------------------------------------------------------
const dlcBnr = () => {
  $("#index-Bnr_Close").on("click", function() {
    $("#index-Bnr").removeClass('show');
  });
};


// ------------------------------------------------------------------------
// showKV
// ----- BOTH
// ------------------------------------------------------------------------
const showKV = () => {

  setTimeout(function(){$('#index-Loader').addClass("load");},0);
  setTimeout(function(){$('#index-Loader_Txt').addClass("hidden");},0);
  setTimeout(function(){$('#index-Loader_Inner').addClass("hidden");},0);
  setTimeout(function(){$('#index-Loader').addClass("hidden");},200);
  setTimeout(function(){$('#index-Loader').remove();},1400);

  setTimeout(function(){$('.js-loadingAnimation').addClass("is-animated");},200);
  setTimeout(function(){$('#index-Bnr').addClass("show");},1800);

};




// ------------------------------------------------------------------------
// movieSlide
// ----- BOTH
// ------------------------------------------------------------------------
const movieSlide = () => {

  var movieSwiper;
  let options = {};
  if ( $(".index-Movie_Item").length == 1 ) {
    //1枚の時
    options = {
      autoHeight: false,
      slidesPerView: 1,
      centeredSlides: true,
      loop: false,
      grabCursor: false,
      watchOverflow: true,//スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
      navigation: {
        nextEl: '.index-Movie_Next',
        prevEl: '.index-Movie_Prev',
        hideOnClick: true,
      },
      breakpoints: {
        1024: {
          spaceBetween: 10,
          slidesPerView: 1
        }
      },
    }
  } else {
    //2枚以上の時
    options = {
      autoHeight: false,
      loop: true,
      loopAdditionalSlides: 1,//一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
      grabCursor: true,
      watchOverflow: true,//スライドの枚数がスライダー生成の条件に満たさない時）、コントロール関係を削除してスライド機能もなくす。
      speed: 600,
      // width: 760,
      centeredSlides: true,
      navigation: {
        nextEl: '.index-Movie_Next',
        prevEl: '.index-Movie_Prev',
        hideOnClick: true,
      },
      breakpoints: {
        1024: {
          spaceBetween: 10,
          slidesPerView: 1
        }
      },
    }
  }

  movieSwiper = new Swiper('.index-Movie_Container', options);

};


// ------------------------------------------------------------------------
// scrollAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ページトップ出現
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Story',
    triggerHook: 1,
    offset: '80'
  })
  .setClassToggle('#st-Top', 'st-Top-Show')
  .addTo(controller);

};



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js